import * as pkg from '@greatsumini/react-facebook-login'

const mod = pkg as any
const FacebookLogin: any =
  typeof mod === 'function' ? mod : mod.default?.default ?? mod.default ?? mod

export default FacebookLogin
